const g50Currencies = [
  { country: 'Japan', pair: 'USD/JPY', seriesId: 'JPNCPIALLMINMEI' },
  { country: 'Japan', pair: 'JPY/USD', seriesId: 'JPNCPIALLMINMEI' },
  { country: 'European Union', pair: 'EUR/USD', seriesId: 'EA19CPALTT01IXOBM' },
  { country: 'United Kingdom', pair: 'GBP/USD', seriesId: 'GBRCPIALLMINMEI' },
  { country: 'New Zealand', pair: 'NZD/USD', seriesId: 'NZLCPIALLMINMEI' },
  { country: 'Canada', pair: 'CAD/USD', seriesId: 'CANCPIALLMINMEI' },
  { country: 'Canada', pair: 'USD/CAD', seriesId: 'CANCPIALLMINMEI' },
  { country: 'Australia', pair: 'AUD/USD', seriesId: 'AUSCPIALLMINMEI' },
  { country: 'Mexico', pair: 'MXN/USD', seriesId: 'MEXCPIALLMINMEI' },
  { country: 'Switzerland', pair: 'USD/CHF', seriesId: 'CHECPIALLMINMEI' },
  { country: 'China', pair: 'CNY/USD', seriesId: 'CHNCPIALLMINMEI' },
  { country: 'Brazil', pair: 'BRL/USD', seriesId: 'BRACPIALLMINMEI' },
  { country: 'EURO GBP', pair: 'EUR/GBP', seriesId: null }, // Not a country-specific series
  { country: 'Singapore', pair: 'SGD/USD', seriesId: 'SGPCPIALLMINMEI' },
  { country: 'Saudi Arabia', pair: 'SAR/USD', seriesId: 'SAUCPIALLMINMEI' },
  { country: 'India', pair: 'INR/USD', seriesId: 'INDCPIALLMINMEI' },
  { country: 'Indonesia', pair: 'IDR/USD', seriesId: 'IDNCPIALLMINMEI' },
  { country: 'Russia', pair: 'RUB/USD', seriesId: 'RUSCPIALLMINMEI' },
  { country: 'South Africa', pair: 'ZAR/USD', seriesId: 'ZAFCPALTT01IXOBQ' },
  { country: 'South Korea', pair: 'KRW/USD', seriesId: 'KORCPIALLMINMEI' },
  { country: 'Turkey', pair: 'TRY/USD', seriesId: 'TURCPIALLMINMEI' },
  { country: 'Argentina', pair: 'ARS/USD', seriesId: 'ARGCPIALLMINMEI' },
  { country: 'Malaysia', pair: 'MYR/USD', seriesId: 'MYSCPALTT01IXOBQ' },
  { country: 'Thailand', pair: 'THB/USD', seriesId: 'THACPIALLMINMEI' },
  { country: 'Philippines', pair: 'PHP/USD', seriesId: 'PHLCPIALLMINMEI' },
  { country: 'Vietnam', pair: 'VND/USD', seriesId: null }, // Not available on FRED
  { country: 'Hong Kong', pair: 'HKD/USD', seriesId: 'HKGCPALTT01IXOBQ' },
  { country: 'Egypt', pair: 'EGP/USD', seriesId: 'EGYCPIALLMINMEI' },
  { country: 'Israel', pair: 'ILS/USD', seriesId: 'ISRCPIALLMINMEI' },
  { country: 'Norway', pair: 'NOK/USD', seriesId: 'NORCPIALLMINMEI' },
  { country: 'Sweden', pair: 'SEK/USD', seriesId: 'SWECPIALLMINMEI' },
  { country: 'Denmark', pair: 'DKK/USD', seriesId: 'DNKCPIALLMINMEI' },
  { country: 'Poland', pair: 'PLN/USD', seriesId: 'POLCPIALLMINMEI' },
  { country: 'Hungary', pair: 'HUF/USD', seriesId: 'HUNCPIALLMINMEI' },
  { country: 'Czech Republic', pair: 'CZK/USD', seriesId: 'CZECPIALLMINMEI' },
  { country: 'Romania', pair: 'RON/USD', seriesId: 'ROUCPIALLMINMEI' },
  { country: 'Chile', pair: 'CLP/USD', seriesId: 'CHLCPIALLMINMEI' },
  { country: 'Colombia', pair: 'COP/USD', seriesId: 'COLCPIALLMINMEI' },
  { country: 'Peru', pair: 'PEN/USD', seriesId: 'PERCPIALLMINMEI' },
  { country: 'Pakistan', pair: 'PKR/USD', seriesId: 'PAKCPIALLMINMEI' },
  { country: 'Bangladesh', pair: 'BDT/USD', seriesId: null }, // Not available on FRED
  { country: 'South Sudan', pair: 'SSP/USD', seriesId: null }, // Not available on FRED
  { country: 'Kenya', pair: 'KES/USD', seriesId: 'KENCPALTT01IXOBQ' },
  { country: 'Nigeria', pair: 'NGN/USD', seriesId: 'NGACPIALLMINMEI' },
  { country: 'Ghana', pair: 'GHS/USD', seriesId: null }, // Not available on FRED
  { country: 'Morocco', pair: 'MAD/USD', seriesId: 'MARCPIALLMINMEI' },
  { country: 'Algeria', pair: 'DZD/USD', seriesId: null }, // Not available on FRED
  { country: 'Bahrain', pair: 'BHD/USD', seriesId: null }, // Not available on FRED
  { country: 'Iran', pair: 'IRR/USD', seriesId: null }, // Not available on FRED
  { country: 'Iraq', pair: 'IQD/USD', seriesId: null }, // Not available on FRED
  { country: 'Jordan', pair: 'JOD/USD', seriesId: null }, // Not available on FRED
  { country: 'Kuwait', pair: 'KWD/USD', seriesId: null }, // Not available on FRED
  { country: 'Lebanon', pair: 'LBP/USD', seriesId: null }, // Not available on FRED
  { country: 'Libya', pair: 'LYD/USD', seriesId: null }, // Not available on FRED
  { country: 'Oman', pair: 'OMR/USD', seriesId: null }, // Not available on FRED
  { country: 'Qatar', pair: 'QAR/USD', seriesId: null }, // Not available on FRED
  { country: 'Syria', pair: 'SYP/USD', seriesId: null }, // Not available on FRED
  { country: 'Tunisia', pair: 'TND/USD', seriesId: null }, // Not available on FRED
  { country: 'United Arab Emirates', pair: 'AED/USD', seriesId: null }, // Not available on FRED
  { country: 'Yemen', pair: 'YER/USD', seriesId: null }, // Not available on FRED
];

export default g50Currencies;
